<template>
  <v-container>
    <v-layout>
    <v-flex>
      <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newPeriod"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Periodo</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo periodo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                    v-model="period.name"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-textarea
                      name="description"
                      label="Descripción"
                      id="description"
                      v-model="period.description"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                  <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="menu"
                      :nudge-right="40"
                      :return-value.sync="date"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="period.start"
                        label="Fecha de inicio"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker v-model="period.start"
                                   @input="$refs.menu.save(period.start)"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                  <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      :return-value.sync="date"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="period.end"
                        label="Fecha de fin"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker v-model="period.end"
                                   @input="$refs.menu.save(period.end)"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-select
                      id="status"
                      :items="statusItems"
                      v-model="period.status"
                      label="Estado"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Periodos por Cliente</h3>
      <v-data-table
        :headers="headers"
        :items="periods"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ props.item.start }}</td>
          <td class="text-xs-left">{{ props.item.end }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="editItem(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Descripción', value: 'description' },
        { text: 'Fecha Inicio', value: 'start' },
        { text: 'Fecha Fin', value: 'end' },
        { text: 'Estado', value: 'status' },
        { text: 'Acciones', value: 'editar' },
      ],
      items: ['TIPO_DOCUMENTO'],
      editedIndex: -1,

      statusItems: ['ACTIVO',
        'INACTIVO'],
      period:{name:"",description:"",start:"",end:"", status:"INACTIVO"},
      periods:[],
      menu: false,
      menu2: false,
      date: "",
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.period={name:"",description:"",start:"",end:"", status:"INACTIVO"},
      this.valid = false;
      this.dialog = false;
    },
    newPeriod() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.period={name:"",description:"",start:"",end:"", status:"INACTIVO"}
    },
    saveData() {
      let active = 0
      for (const per of this.periods) {
        if((per.status=='ACTIVO' && this.period.status=='ACTIVO')){
          active++;
        }
      }
      if(active>0){
        this.$store.state.dialogError = true;
        this.$store.state.dialogErrorMessage = "Solo debe existir un periodo en estado activo";

      }else{
        if (this.$refs.form.validate()) {
          this.period.company =  {id:this.$store.state.companyActivity.id}
          if (this.editedIndex > -1) {
            this.$store.dispatch('updateCompanyPeriod', this.period).then(
                response => {
                  this.reloadData();
                },
                error => {
                  this.$store.state.progress = false;
                  this.$store.state.dialogError = true;
                }
            );
          } else {
            this.$store.dispatch('addCompanyPeriod', this.period).then(
                response => {
                  this.reloadData();
                },
                error => {
                  this.$store.state.progress = false;
                  this.$store.state.dialogError = true;
                }
            );
          }
          this.dialog = false;
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.periods.indexOf(item);
      this.period = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex =this.periods.indexOf(item);
      this.period = Object.assign({}, item);
      if(confirm('Está seguro de que quiere eliminar el registro?')){
        this.$store.dispatch('deleteCompanyPeriod', this.period.id).then(
            response => {
              this.reloadData()
            },
        )

      }
    },
    reloadData(){
      this.period={name:"",description:"",start:"",end:"", status:"INACTIVO"},
      this.periods=[]
      this.$store.dispatch('getCompanyPeriodByCompany',this.$store.state.companyActivity.id).then(
          response => {
            this.periods = response.data
          },
          error => {
            this.$store.state.dialogError = true;
          }
      );
    }

  },
  computed: {},
  created() {
    this.reloadData()
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activityCompany/ActivityCompanyPeriod.vue